import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
  name: "filters",
  initialState: {
    filterApplied: false,
    range: {
      startDate: null,
      endDate: new Date().toISOString(),
      key: "range",
    },
    startTime: new Date().toISOString(),
    endTime: new Date().toISOString(),
    cameras: [],
    species: [],
    showUntagged: false,
  },
  reducers: {
    setTimeRange: (state, action) => {
      // Convert Date objects to ISO strings
      state.startTime =
        action.payload.startTime instanceof Date
          ? action.payload.startTime.toISOString()
          : action.payload.startTime;
      state.endTime =
        action.payload.endTime instanceof Date
          ? action.payload.endTime.toISOString()
          : action.payload.endTime;
    },
    setFilterApplied: (state, action) => {
      state.filterApplied = action.payload;
    },
    setDateRange: (state, action) => {
      // Convert Date objects to ISO strings
      state.range = {
        startDate:
          action.payload.startDate instanceof Date
            ? action.payload.startDate.toISOString()
            : action.payload.startDate
              ? new Date(action.payload.startDate).toISOString()
              : null,
        endDate:
          action.payload.endDate instanceof Date
            ? action.payload.endDate.toISOString()
            : action.payload.endDate
              ? new Date(action.payload.endDate).toISOString()
              : new Date().toISOString(),
        key: action.payload.key || "range",
      };
    },
    setCameras: (state, action) => {
      let cameraIds = action.payload;
      if (Array.isArray(cameraIds)) {
        const flatIds = [];
        for (let i = 0; i < cameraIds.length; i++) {
          if (Array.isArray(cameraIds[i])) {
            flatIds.push(...cameraIds[i]);
          } else {
            flatIds.push(cameraIds[i]);
          }
        }
        state.cameras = flatIds;
      } else {
        state.cameras = cameraIds;
      }
    },
    setSpecies: (state, action) => {
      state.species = action.payload;
    },
    setShowUntagged: (state, action) => {
      state.showUntagged = action.payload;
    },
    resetFilters: (state) => {
      state.filterApplied = false;
      state.range = {
        startDate: null,
        endDate: new Date().toISOString(),
        key: "range",
      };
      state.startTime = new Date().toISOString();
      state.endTime = new Date().toISOString();
      state.cameras = [];
      state.species = [];
      state.showUntagged = false;
    },
  },
});

// Action creators
export const {
  setDateRange,
  setCameras,
  setSpecies,
  setFilterApplied,
  setTimeRange,
  resetFilters,
  setShowUntagged,
} = filterSlice.actions;
export const selectFilters = (state) => state.filters;

export default filterSlice.reducer;
